import script from "./MassesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MassesTable.vue?vue&type=script&setup=true&lang=js"

import "./MassesTable.vue?vue&type=style&index=0&id=8b6a2d2c&lang=css"

const __exports__ = script;

export default __exports__